import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-charge-list-view',
  imports: [],
  templateUrl: './charge.list-view.html',
  styleUrls: ['./charge.list-view.css'],
})
export class ChargeListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
